class BannerNextButton {
	constructor(bannerEl, buttonEl) {
		this.banner = bannerEl;
		this.button = buttonEl;

		if (this.banner && this.button) {
			this.button.addEventListener('click', (e) => this.handleClick(e));
		}
	}

	handleClick(e) {
		e.preventDefault();

		let nextSection = null;

		const mainSections = Array.from(document.querySelectorAll('main section'));

		if (mainSections.length) {
			if (mainSections[0].classList.contains('second-navigation__submenu-container')) {
				nextSection = mainSections[1] || null;
			} else {
				nextSection = mainSections[0];
			}
		}

		if (!nextSection) {
			const mainEl = document.querySelector('main');
			if (mainEl) {
				let sibling = mainEl.nextElementSibling;
				while (sibling) {
					if (sibling.tagName.toLowerCase() === 'section') {
						nextSection = sibling;
						break;
					}
					sibling = sibling.nextElementSibling;
				}
			}
		}

		if (nextSection) {
			nextSection.scrollIntoView({ behavior: 'smooth' });
		} else {
		}
	}
}

export default BannerNextButton;
